module.exports = __webpack_public_path__ + "static/jc04657-preparation-administration-1-bd5d663afcfe65bddf127f4998f3aebc.png";